<template>
    <div class="row g-3 mb-4">
        <div ref="headerRef"
            class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer"
            @click="toggleSection">
            <h6 class="fw-bold mb-0">{{ title }}</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">
                <div class="col-md-8">
                    <label class="form-label small">Cena za pojazd</label>
                    <input type="number" step="0.01" class="form-control" v-model.number="form.carPrice" required />
                </div>
                <div class="col-md-4">
                    <label class="form-label small">Waluta</label>
                    <select class="form-select" v-model="form.carCurrency">
                         <option v-for="r in dicts?.currencies" :key="r.ID || r.id || r" :value="r.name || r.label || r">
                            {{ r.name || r.label || r }}
                        </option>
                    </select>
                </div>
                <div class="col-md-8">
                    <label class="form-label small">Komisant otrzymuje (prowizja)</label>
                    <input type="number" step="0.01" class="form-control" v-model.number="form.commissionAmount"
                        required />
                </div>
                <div class="col-md-4">
                    <label class="form-label small">Waluta</label>
                    <select class="form-select" v-model="form.commissionCurrency">
                         <option v-for="r in dicts?.currencies" :key="r.ID || r.id || r" :value="r.name || r.label || r">
                            {{ r.name || r.label || r }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, computed, nextTick } from 'vue'

const props = defineProps({
    modelValue: { type: Object, required: true },
    title: { type: String, default: 'Cena' },
    dicts: { type: Object, default: () => ({ makes: [], models: [], gearboxes: [], fuelTypes: [], colours: [] }) },
    lastDocuments: { type: Array, default: () => [] }
})
const emit = defineEmits(['update:modelValue', 'makeChange', 'saveCarToOffers'])

const headerRef = ref(null)
const sectionCollapse = ref(false)

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>